<div class="offline-locations">
  <div class="offline-location" *ngFor="let location of locations | slice: start : end">
    <div class="d-flex flex-row justify-content-between p-4">
      <p class="font-weight-bold" [innerText]="location.name"></p>

      <tablesready-sms-usage
        [subscriptionType]="accountSubscriptionType"
        [usage]="location.usage"
        [showPrice]="false"
        [timezone]="location.timezone"
      ></tablesready-sms-usage>
    </div>
  </div>
</div>
<div class="d-flex flex-row justify-content-end pt-2">
  <div class="pagination">
    <ngb-pagination
      [(page)]="locationPageIndex"
      [pageSize]="locationPageSize"
      [maxSize]="maxDisplayPages"
      [ellipses]="true"
      [collectionSize]="locations.length"
    ></ngb-pagination>
  </div>
</div>
